export default __webpack_public_path__ + "static/media/voucher-back.91c55a19.svg";